<template>
  <div class="animated revealUp po_wrapper">
    <div class="section-title mb-3">Create Property In/Out</div>
    <section class="white-wrapper">
      <form class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedCinema"
                label="cine_name"
                track-by="cine_id"
                :placeholder="$t('Cinema')"
                :options="Cinemas"
                @select="onSelectCinema($event)"
                @remove="onSelectCinema($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>
        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedType"
                label="type"
                track-by="type_id"
                :placeholder="'Select Action'"
                :options="TypeList"
                @select="onSelectType($event, 'select')"
                @remove="onSelectType($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && !selectedType">Please Select Type.</span>
          </p>
        </div>

        <div
          class="w-100"
          v-if="propertyInOutDetails.cinema_id && propertyInOutDetails.type_id"
        >
          <b-collapse
            v-model="collapseObj.itemsArray"
            class="pt-3 px-2 bor mb-4 back collapse show w-100 purchase_table"
          >
            <section class="row">
              <div class="w-100 mx-3 mb-3">
                <span
                  class="redLine"
                  v-if="
                    LogsErrorDetails['hasError'] && LogsErrorDetails['errorMsg']
                  "
                  >{{ LogsErrorDetails["errorMsg"] }}</span
                >
                <table
                  class="swc-report-table po_table"
                  border="1"
                  style="table-layout: auto; background: white"
                >
                  <thead class="tableHeaderSticky">
                    <tr>
                      <th class="bg-lightgrey p-1" style="width: 320px">
                        Item
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 85px">QTY</th>
                      <th class="bg-lightgrey p-1" style="width: 65px">Unit</th>
                      <th class="bg-lightgrey p-1" style="width: 182px">
                        Remark
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 80px">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="RawMaterialsList.length > 0">
                    <tr
                      v-for="(item, vendorIndex) in RawMaterialsList"
                      :key="`${vendorIndex}${vendorIndex}`"
                      :class="
                        errIndex == vendorIndex
                          ? 'errRow'
                          : LogsErrorDetails['hasError'] &&
                            LogsErrorDetails['errorIndexArray'].includes(
                              vendorIndex
                            )
                          ? 'errorLine'
                          : !isNaN(String(item['qty'])) &&
                            item['rm_id'] &&
                            !item['qty']
                          ? ''
                          : ''
                      "
                    >
                      <td class="text-left p-0 po_item">
                        <multiselect
                          :key="`___${vendorIndex}${vendorIndex}`"
                          :class="`___${vendorIndex}${vendorIndex}`"
                          :options="RawMaterials"
                          v-model="item.SelectedRawMaterial"
                          :searchable="true"
                          label="rm_name"
                          track-by="rm_id"
                          placeholder=" Raw Material"
                          @select="onSelectRawMaterial($event, vendorIndex, 0)"
                          @remove="
                            onSelectRawMaterial(
                              $event,
                              vendorIndex,
                              0,
                              'remove'
                            )
                          "
                          :showLabels="false"
                        >
                         <template slot="option" slot-scope="props">
                                  <span>{{
                                    props.option.rm_name
                                  }}</span>
                                  <span
                                    v-if="
                                      props.option.hasOwnProperty(
                                        '$isDisabled'
                                      ) && props.option['$isDisabled']
                                    "
                                    class="text-truncate"
                                    style="
                                      font-size: 10px !important;
                                      color: red;
                                    "
                                    >&nbsp;{{ "No Rates Found. Please Add Vendor Rates" }}
                                  </span>
                                </template>
                        </multiselect>
                      </td>
                      <td class="text-center p-0 font-weight-bold">
                        <div class="input_text-center">
                          <input
                            v-model="item.qty"
                            :name="`item_qty_${vendorIndex}`"
                            :id="`item_qty_${vendorIndex}`"
                            type="number"
                            class="qtyInput purchase_input"
                            placeholder="Qty"
                          />
                        </div>
                      </td>
                      <td class="text-center p-0 po_item font-weight-bold">
                        {{ item.uom_unit }}
                      </td>
                      <td class="text-center p-0 po_item">
                        <textarea
                          rows="1"
                          style="border-radius: 5px"
                          class="w-100 form-control form-control-sm"
                          placeholder
                          type="text"
                          v-model="item.remarks"
                          :id="`textarea-${item.vendorIndex}`"
                        ></textarea>
                      </td>
                      <td>
                        <div
                          class="icon-sm-minus blue-icon ml-2 btn"
                          @click="removeVendor(vendorIndex)"
                        ></div>
                      </td>
                    </tr>
                    <tr class="">
                      <td colspan="11">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click="addVendor()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="">
                      <td colspan="10"></td>
                    </tr>
                    <tr class="">
                      <td colspan="10">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click="addVendor()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </b-collapse>
        </div>

        <div class="col-md-12 mb-4 text-center">
          <button
            :disabled="btenable"
            v-if="
              propertyInOutDetails.cinema_id && propertyInOutDetails.type_id
            "
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}</button
          >&nbsp;
          <router-link
            to="property-in-out"
            class="btn btn-default btn-outline-grey"
            >{{ $t("cancel") }}</router-link
          >
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import { CLIENT_NAME } from "@/helper/Role";

export default {
  data() {
    return {
      LogsErrorDetails: {
        errorMsg: "",
        hasError: false,
        errorIndexArray: [],
      },
      showAll: false,
      errIndex: null,
      collapseObj: {
        itemsArray: true,
        item_array: true,
      },
      btenable: false,
      isRoleID: true,
      submitted: false,
      propertyInOutDetails: {
        cinema_id: null,
        sm_id: null,
        type_id: null,
        fromDate: new Date(),
        remarks: "",
      },
      TypeList: [
        {
          type_id: 1,
          type: "Property In",
        },
        {
          type_id: 2,
          type: "Property Out",
        },
      ],
      RawMaterialsList: [
        {
          rm_id: "",
          qty: "",
          uom_unit: "",
          uom_id: "",
          SelectedRawMaterial: null,
          selectedUOM: null,
          remarks: "",
        },
      ],
      Cinemas: [],
      CinemasCopy: [],
      RawMaterials: [],
      selectedCinema: "",
      selectedType: "",
      selectedUom: "",
      rawMaterialsNew: [],
      selectedRawMaterialPrice: [],
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
    this.getRawMaterialsListMain();
  },
  mounted() {
    console.log("BUILD check");
    this.RawMaterialsList = Array.from({ length: 10 }, () => ({
      rm_id: "",
      qty: "",
      uom_unit: "",
      uom_id: "",
      SelectedRawMaterial: null,
      selectedUOM: null,
      remarks: "",
    }));

    // this.getRawMaterials();
    // this.getunitsofmeasurements();
  },
  computed: {
    defaultTaxPercent() {
      let taxPercent = "";
      if (CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME) {
        taxPercent = 10;
      }
      return taxPercent;
    },
    isEpix() {
      return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
    },
  },
  methods: {
    onSelectType(event, type) {
      if (type == "remove") {
        this.selectedType = null;
        this.propertyInOutDetails["type_id"] = null;
      } else {
        this.selectedType = event;
        this.propertyInOutDetails["type_id"] = event.type_id;
      }
    },
    filterRW(rm) {
      let filtered = rm.filter((rm) => {
        if (!this.purchasOrderDetails.v_id) return true;

        let v_ids = (rm.vendor_ids || "")
          .split(",")
          .map((x) => String(x).trim())
          .map((x) => parseInt(x));

        if (!rm.vendor_ids) return false;
        return v_ids.includes(parseInt(this.purchasOrderDetails.v_id));
      });
      return filtered;
    },
    getRawMaterialsListMain: function () {
      this.RawMaterials = [];
      let payload = {
        limit: 10000,
        currentPage: 1,
        searchKey: "rm_name",
        searchValue: "",
        columnName: "rm_name",
        orderBy: "asc",
        filter_is_active: "Y",
      };
      PosFnbService.GetRawMaterialsList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.forEach((rm) => {
              if(rm.hasOwnProperty('vendor_ids') && rm.vendor_ids == "") {
                rm['$isDisabled'] = true
              } else {
                  rm['$isDisabled'] = false
              }
            })

            this.RawMaterials = data.Records;

            console.log(this.rawMaterialsNew);
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError); //message
    },
    clearSelectedDate: function () {
      this.propertyInOutDetails.fromDate = "";
    },
    getCinemasList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema({
                  cine_id: x.cine_id,
                  cine_name: x.cine_name,
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectCinema: function (params, type) {
      if (type == "remove") {
        this.selectedCinema = "";
        this.propertyInOutDetails.cinema_id = null;
      } else {
        this.selectedCinema = params;
        this.propertyInOutDetails.cinema_id = params.cine_id;
      }
    },
    onSelectRawMaterial: function (params, index, rawkey, type) {
      if (type == "remove") {
        this.RawMaterialsList[index].rm_id = null;
        this.RawMaterialsList[index].SelectedRawMaterial = "";
        this.RawMaterialsList[index].selectedUOM = "";
        this.RawMaterialsList[index].uom_unit = "";
        this.RawMaterialsList[index].uom_id = null;
        this.RawMaterialsList[index].qty = "";
      } else {
        let findIndexNew = this.RawMaterialsList.findIndex((x) => {
          return x.rm_id == String(params.rm_id);
        });
        if (findIndexNew < 0) {
          this.RawMaterialsList[index].rm_id = params.rm_id;
          this.RawMaterialsList[index].SelectedRawMaterial = params;
          this.RawMaterialsList[index].selectedUOM = {
            uom_id: params.uom_id,
            uom_short_form: params.uom_short_form,
            uom_unit: params.uom_unit,
          };
          this.RawMaterialsList[index].uom_unit = params.uom_short_form;
          this.RawMaterialsList[index].uom_id = params.uom_id;
          this.RawMaterialsList[index].qty = "";
        } else {
          this.$toasted.show(` ${params.rm_name} already selected `);
          this.RawMaterialsList[index].rm_id = null;
          this.RawMaterialsList[index].SelectedRawMaterial = "";
          this.RawMaterialsList[index].selectedUOM = "";
          this.RawMaterialsList[index].uom_unit = "";
          this.RawMaterialsList[index].uom_id = null;
          this.RawMaterialsList[index].qty = "";
          this.$forceUpdate();
        }
      }
    },
    addVendor: function () {
      this.RawMaterialsList.push({
        rm_id: "",
        qty: "",
        uom_unit: "",
        uom_id: "",
        SelectedRawMaterial: null,
        selectedUOM: null,
        remarks: "",
      });
    },
    removeVendor: function (index) {
      this.RawMaterialsList.splice(index, 1);
    },
    validatePurchaseOrderArray() {
      let errorCount = 0;
      let errorMsg = ``;
      let errIndex = null;
      this.LogsErrorDetails["hasError"] = false;
      this.LogsErrorDetails["errorMsg"] = "";
      this.LogsErrorDetails["errorIndexArray"] = [];
      this.RawMaterialsList.map((row, index) => {
        if (row.rm_id) {
          console.log('row validatePurchaseOrderArray', row);
          if (!row.qty) {
            errorCount++;
            errorMsg = `Please Enter Valid Qty.`;
            errIndex = index;

            this.LogsErrorDetails["hasError"] = true;
            this.LogsErrorDetails["errorMsg"] = errorMsg;
            this.LogsErrorDetails["errorIndexArray"].push(index);
          } else if (row.remarks == "") {
            errorCount++;
            errorMsg = `Please Enter Remarks.`;
            errIndex = index;

            this.LogsErrorDetails["hasError"] = true;
            this.LogsErrorDetails["errorMsg"] = errorMsg;
            this.LogsErrorDetails["errorIndexArray"].push(index);
          }
        }
      });
      if (errorCount > 0) {
        console.log("this.LogsErrorDetails", this.LogsErrorDetails);
        this.$toasted.show(errorMsg);
        return false;
      } else {
        return true;
      }
    },
    onFinalSubmit: function () {
      this.submitted = true;
      let checkValid = this.validatePurchaseOrderArray();
      let finalPurchaseArray = this.RawMaterialsList.filter(
        (x) => x.rm_id && x.uom_id && !isNaN(String(x.qty)) && x.qty > 0
      );
      this.$validator.validate().then((valid) => {
        if (valid && checkValid) {
          let loader = this.$loading.show();

          this.btenable = true;
          let payload = {
            ...this.propertyInOutDetails,
            rawMaterialList: finalPurchaseArray,
          };
          PosFnbService.AddPropertyInOut(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "property-in-out",
                });
              } else {
                this.$toasted.show(data.message);
              }
              loader.hide();
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>

<style>
.sectionName {
  padding: 5px 0px;
  color: #4a87e1;
}
.sectionName .fs-17 {
  font-size: 17px !important;
}
.text-small-instruction {
  font-weight: 400;
}
.text-red {
  color: red;
}

.percentText {
  color: black;
  font-size: 15px;
  font-weight: bold;
  position: relative;
  padding-inline: 8px;
}

.qtyInput {
  border-radius: 5px;
  border: 1px solid #777575;
  width: 80%;
  height: 30px;
}

.disable-field {
  cursor: not-allowed;
  opacity: 0.5;
}
.bor {
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}
.back {
  background-color: #f5f5f5;
}
.inner-vendor-rate {
  background-color: #fff;
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}

.po_item .multiselect__tags {
  border-radius: unset !important;
  border: unset !important;
}

.po_input input {
  border: none;
  height: 40px;
  margin: 0;
  width: 100%;
  padding-inline: 10px;
}

.po_input input::placeholder,
.po_wrapper .multiselect__placeholder {
  font-size: 10px !important;
  font-style: italic !important;
}

.input_text-center input {
  text-align: center;
}

.input_text-right input {
  text-align: right;
}

.po_wrapper .multiselect__placeholder {
  font-weight: unset !important;
  line-height: 25px;
}

.purchase_input::placeholder {
  font-size: 10px !important;
  font-style: italic !important;
}

.noItemsClass {
  text-align: center;
  width: 100%;
  margin: 16px auto;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
}

.taxPopOver {
  zoom: 0.8;
  min-width: 200px;
}

.errRow {
  border: 2px solid red;
}
.borderNone {
  border: none !important;
}

.complete-tick {
  width: 120px;
  height: 120px;
  display: inline-block;
  background-size: contain;
}

.errorLine {
  color: red;
  border: 1px solid red;
}

.redLine {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PropertyInOutComponents/addPropertyInOut.vue